import { render, staticRenderFns } from "./FacebookConfig.vue?vue&type=template&id=9f185936&lang=pug"
import script from "./FacebookConfig.vue?vue&type=script&lang=js"
export * from "./FacebookConfig.vue?vue&type=script&lang=js"
import style0 from "./FacebookConfig.vue?vue&type=style&index=0&id=9f185936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports